<template>
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
  >
    <path d="M0 0.5C0 0.223858 0.223858 0 0.5 0H11.5C11.7761 0 12 0.223858 12 0.5C12 0.776142 11.7761 1 11.5 1H0.5C0.223858 1 0 0.776142 0 0.5ZM2 4.5C2 4.22386 2.22386 4 2.5 4H9.5C9.77614 4 10 4.22386 10 4.5C10 4.77614 9.77614 5 9.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM4 8.5C4 8.22386 4.22386 8 4.5 8H7.5C7.77614 8 8 8.22386 8 8.5C8 8.77614 7.77614 9 7.5 9H4.5C4.22386 9 4 8.77614 4 8.5Z" />
  </svg>
</template>
